import { formatUSD } from "@/lib/marketplaceTerms";

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  return isNaN(d) ? "" : d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
};

export const PaymentProgressCard = ({ summary }) => {
  if (!summary || !(Number(summary.net_collected) > 0)) return null;
  const total = Number(summary.quote_amount) || 0;
  const paid = Number(summary.net_collected) || 0;
  const pct = total > 0 ? Math.min(100, Math.round((paid / total) * 100)) : 0;
  const due = fmtDate(summary.due_date);
  return (
    <div className="card-elegant p-6" data-testid="payment-progress-card">
      <div className="eyebrow">Payment progress</div>
      <div className="mt-3 h-2 rounded-full bg-[#EFEADF] overflow-hidden">
        <div className="h-full bg-[color:var(--verified)] transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      <dl className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
        <dt className="text-[color:var(--text-muted)]">Total</dt>
        <dd className="text-right font-semibold" data-testid="progress-total">{formatUSD(total)}</dd>
        <dt className="text-[color:var(--text-muted)]">Paid</dt>
        <dd className="text-right font-semibold" data-testid="progress-paid">{formatUSD(paid)}</dd>
        {Number(summary.refunded) > 0 && (<>
          <dt className="text-[color:var(--text-muted)]">Refunded</dt>
          <dd className="text-right" data-testid="progress-refunded">{formatUSD(summary.refunded)}</dd>
        </>)}
        <dt className="text-[color:var(--text-muted)]">Remaining</dt>
        <dd className="text-right font-semibold" data-testid="progress-remaining">
          {summary.fully_paid ? "Paid in full" : formatUSD(summary.remaining)}
        </dd>
        {!summary.fully_paid && Number(summary.remaining) > 0 && due && (<>
          <dt className="text-[color:var(--text-muted)]">Due by</dt>
          <dd className="text-right" data-testid="progress-due-date">{due}</dd>
        </>)}
      </dl>
      {summary.payments?.length > 0 && (
        <ul className="mt-4 pt-3 border-t border-[color:var(--border)] space-y-1 text-xs text-[color:var(--text-muted)]" data-testid="progress-payments">
          {summary.payments.map((p, i) => (
            <li key={i} className="flex justify-between" data-testid={`progress-payment-${i}`}>
              <span>{p.kind === "balance" ? "Balance payment" : "Deposit"} · {fmtDate(p.paid_at)}</span>
              <span>{formatUSD(p.amount)}{p.refunded > 0 ? ` (−${formatUSD(p.refunded)})` : ""}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export { fmtDate };
